import { render } from "./NavbarVertical.vue?vue&type=template&id=1f00b578&scoped=true"
import script from "./NavbarVertical.vue?vue&type=script&lang=js"
export * from "./NavbarVertical.vue?vue&type=script&lang=js"

import "./NavbarVertical.vue?vue&type=style&index=0&id=1f00b578&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f00b578"]])

export default __exports__